import users from './userInfo'

export function getModules() {
  return { users }
}
